module.exports = __webpack_public_path__ + "static/media/logo.eb8dcdfe.svg";